var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "third-party-pickup" },
    [
      _c(
        "div",
        { staticClass: "toggle-row", on: { click: _vm.toggleEnabled } },
        [
          _c("span", { staticClass: "toggle-label" }, [
            _vm._v("Family or friends will collect bags on my behalf")
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "toggle-switch", class: { on: _vm.enabled } },
            [_c("span", { staticClass: "toggle-knob" })]
          )
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "panel-slide" } }, [
        _vm.enabled
          ? _c("div", { staticClass: "pickup-fields" }, [
              _c("div", { staticClass: "name-row" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v("First Name")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "field-input",
                    attrs: { type: "text", placeholder: "First name" },
                    domProps: { value: _vm.data.other_first_name },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "other_first_name",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v("Last Name")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "field-input",
                    attrs: { type: "text", placeholder: "Last name" },
                    domProps: { value: _vm.data.other_last_name },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "other_last_name",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "name-row" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v("Passport Number")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "field-input",
                    attrs: { type: "text", placeholder: "Passport" },
                    domProps: { value: _vm.data.other_passport },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "other_passport",
                          $event.target.value
                        )
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "field" }, [
                  _c("label", { staticClass: "field-label" }, [
                    _vm._v("Licence Number")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "field-input",
                    attrs: { type: "text", placeholder: "Licence" },
                    domProps: { value: _vm.data.other_licence },
                    on: {
                      input: function($event) {
                        return _vm.updateField(
                          "other_licence",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "field-label" }, [_vm._v("Email")]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "field-input",
                  attrs: { type: "email", placeholder: "email@example.com" },
                  domProps: { value: _vm.data.other_email },
                  on: {
                    input: function($event) {
                      return _vm.updateField("other_email", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "field-label" }, [
                  _vm._v("Mobile Number")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "phone-row" },
                  [
                    _c("PhonePrefixSelect", {
                      staticClass: "phone-prefix",
                      attrs: { value: _vm.data.other_mobile_prefix || "+61" },
                      on: {
                        change: function($event) {
                          return _vm.updateField("other_mobile_prefix", $event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "field-input phone-number",
                      attrs: { type: "tel", placeholder: "412 345 678" },
                      domProps: { value: _vm.data.other_mobile_number },
                      on: {
                        input: function($event) {
                          return _vm.updateField(
                            "other_mobile_number",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-078f5bcb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-078f5bcb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThirdPartyPickup.vue
// module id = 425
// module chunks = 0